import type { AppRouteRecordRaw } from "../types/types";

import accountHealthRoutes from "@/app/router/accountHealth";
import advertisingRoutes from "@/app/router/advertising";
import categoryRoutes from "@/app/router/category";
import productRatingAndReviewsRoutes from "@/app/router/productRatingAndReviews";
import { RouteNames } from "@/app/router/types/names";
import { Permissions } from "@/shared/constants";

export const productRoutes: AppRouteRecordRaw[] = [
  {
    path: "/insightful",
    name: RouteNames.SOINSIGHTFUL,
    component: () => import("@/pages/InsightFul.vue"),
    meta: {
      pageKey: "SOInsightful",
      title: "SO Insightful",
      menuIcon: "lucide:lightbulb",
      menuTitle: "Insightful",
      permissions: [Permissions.INSIGHTFUL],
    },
  },
  {
    path: "/sales-and-traffic",
    name: RouteNames.SALES_AND_TRAFFIC,
    component: () => import("@/pages/SalesAndTraffic.vue"),
    meta: {
      pageKey: "SalesAndTraffic",
      title: "Sales and Traffic",
      menuIcon: "lucide:circle-dollar-sign",
      permissions: [Permissions.SALES_REPORT],
      vendorPermissions: [Permissions.READ_VENDOR_REPORT_SALES],
      partnerships: ["seller", "vendor"],
    },
  },
  {
    path: "/product-returns",
    name: RouteNames.PRODUCT_RETURNS,
    component: () => import("@/pages/ProductReturns.vue"),
    meta: {
      pageKey: "ProductReturns",
      title: "Product Returns",
      menuIcon: "lucide:package-x",
      permissions: [Permissions.RETURNS],
    },
  },
  ...advertisingRoutes,
  ...productRatingAndReviewsRoutes,
  {
    path: "/inventory",
    name: RouteNames.INVENTORY,
    meta: {
      pageKey: "Inventory",
      filters: {
        show: ["brands", "channels", "products"],
      },
      title: "Inventory",
      menuIcon: "lucide:boxes",
      permissions: [Permissions.INVENTORY],
    },
    component: () => import("@/pages/InventoryReview.vue"),
  },
  ...categoryRoutes,
  {
    path: "/product-performance",
    name: RouteNames.PERFORMANCE,
    component: () => import("@/pages/ProductPerformance.vue"),
    meta: {
      pageKey: "ProductPerformance",
      title: "Product Performance",
      menuIcon: "lucide:trending-up",
      permissions: [Permissions.PERFORMANCE],
      filters: {
        hide: ["granularity"],
      },
    },
  },
  {
    path: "/product-tiers",
    name: RouteNames.PRODUCT_TIERS,
    component: () => import("@/pages/ProductTiers.vue"),
    meta: {
      pageKey: "ProductTiers",
      title: "Product Tiers",
      menuIcon: "lucide:layers",
      permissions: [Permissions.PRODUCT_TIERS],
      filters: {
        show: ["brands", "channels", "products", "dateRange"],
      },
    },
  },
  ...accountHealthRoutes,
  {
    path: "/customer-analytics",
    name: RouteNames.CUSTOMER_ANALYTICS,
    component: () => import("@/pages/CustomerAnalytics.vue"),
    meta: {
      pageKey: "CustomerAnalytics",
      title: "Customer Analytics",
      menuIcon: "lucide:users",
      permissions: [Permissions.CUSTOMER_ANALYTICS],
      filters: {
        show: ["channels", "dateRange", "granularity:onlyMonth", "brands", "products", "comparison"],
      },
    },
  },
  {
    path: "/profit-analysis",
    name: RouteNames.PROFIT_ANALYSIS,
    component: () => import("@/pages/ProfitAnalysis.vue"),
    meta: {
      pageKey: "ProfitAnalysis",
      title: "Profit & Margin Analysis",
      menuTitle: "Profit Analysis",
      menuIcon: "lucide:chart-pie",
      permissions: [Permissions.PROFIT_ANALYSIS],
      filters: {
        show: ["brands", "granularity", "dateRange"],
      },
    },
  },
  {
    path: "/business-review",
    name: RouteNames.BUSINESS_REVIEW,
    component: () => import("@/pages/BusinessReview.vue"),
    meta: {
      pageKey: "BusinessReview",
      title: "Business Review",
      menuIcon: "lucide:clipboard-list",
      permissions: [Permissions.BUSINESS_REVIEW],
      filters: {
        show: ["brands", "channels", "dateRange", "granularity:withoutDay"],
      },
    },
  },
  {
    path: "/halo-effect",
    name: RouteNames.HALO_EFFECT,
    component: () => import("@/pages/HaloEffect.vue"),
    meta: {
      pageKey: "HaloEffect",
      title: "Halo Effect",
      menuIcon: "lucide:waves",
      permissions: [Permissions.HALO_EFFECT],
      filters: {
        show: ["brands", "granularity", "dateRange"],
      },
    },
  },
  {
    path: "/warehouse",
    name: RouteNames.WAREHOUSE,
    meta: {
      pageKey: "Warehouse",
      permissions: [Permissions.WAREHOUSE],
      title: "Warehouse Management",
      menuTitle: "Warehouse",
      menuIcon: "lucide:warehouse",
      filters: {
        hide: ["channels"],
      },
    },
    component: () => import("@/pages/WarehousePage.vue"),
  },
];

export default productRoutes;
